import { fetchWithRefresh } from "../../api/FetchWithRefresh";
import { useState, useCallback } from "react";
import { logger } from "../../observability/LoggerFactory";

type DeletionState =
  | { kind: "idle" }
  | { kind: "loading" }
  | { kind: "success" }
  | { kind: "error"; message: string };

export interface UseDeleteRoleResult {
  deletion: DeletionState;
  deleteRole: (id: string) => void;
  resetDeletion: () => void;
}

export function useDeleteRole(onDeleted: () => void): UseDeleteRoleResult {
  const [deletion, setDeletion] = useState<DeletionState>({ kind: "idle" });

  const deleteRole = useCallback(
    (id: string) => {
      void (async () => {
        setDeletion({ kind: "loading" });
        try {
          const response = await fetchWithRefresh(`/api/roles/${id}`, { method: "DELETE" });
          if (!response.ok) {
            const isConflict = response.status === 409;
            throw new Error(isConflict ? "Нельзя удалить роль: её используют пользователи" : "Не удалось удалить роль");
          }
          setDeletion({ kind: "success" });
          onDeleted();
        } catch (error: unknown) {
          const message = error instanceof Error ? error.message : "Не удалось удалить роль";
          logger.error({ err: message }, "Failed to delete role");
          setDeletion({ kind: "error", message });
        }
      })();
    },
    [onDeleted],
  );

  const resetDeletion = useCallback(() => {
    setDeletion({ kind: "idle" });
  }, []);

  return { deletion, deleteRole, resetDeletion };
}
